import type { AttentionItem } from './api'

const KEY = 'attention-snoozed-until'
const today = () => new Date().toISOString().slice(0, 10)

/** Show the popup at most once per day; respects a "remind me tomorrow" snooze. */
export function attentionDue(pastDue: AttentionItem[], dueSoon: AttentionItem[]): boolean {
  if (pastDue.length + dueSoon.length === 0) return false
  try {
    return (localStorage.getItem(KEY) ?? '') <= today()
  } catch {
    return true
  }
}

export function snoozeAttention(): void {
  const t = new Date()
  t.setDate(t.getDate() + 1)
  try {
    localStorage.setItem(KEY, t.toISOString().slice(0, 10))
  } catch {
    /* ignore */
  }
}
